import queries from '@apis/queries';
import useResetPage from '@hooks/useResetPage';
import { CouponRow, GetCouponsParams } from '@models/coupon';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

function useCouponHistories() {
  const [page, setPage] = useState<number>(0);
  const [sort, setSort] = useState<'IssuedAtDesc' | 'ExpiresAtAsc'>('IssuedAtDesc');
  const params: GetCouponsParams = {
    page,
    size: 10,
    sorter: sort,
  };
  const [coupons, setCoupons] = useState<CouponRow[]>([]);
  const { data, status } = useQuery(queries.coupons.history(params));
  const isEmpty = coupons.length === 0 && status !== 'pending';
  const fetchNext = () => {
    if (data && !data.slice.empty && status === 'success') {
      setPage((prev) => prev + 1);
    }
  };
  useEffect(() => {
    if (data) {
      if (data.slice.first) {
        setCoupons(data.content);
      } else {
        setCoupons((prev) => [...prev, ...data.content]);
      }
    }
  }, [data]);
  useResetPage({ params, setPage });
  return {
    coupons, fetchNext, isEmpty, sort, setSort,
  };
}

export default useCouponHistories;
